/* eslint-disable react-hooks/exhaustive-deps */
import { Box, Button, Modal, ModalBody, ModalCloseButton, ModalContent, ModalHeader, ModalOverlay } from '@chakra-ui/react';
import _ from 'lodash';
import moment from 'moment';
import 'moment/locale/km';
import { useEffect, useState } from 'react';
import ReactExport from 'react-export-excel';
import { useTranslation } from 'react-i18next';
import c from '../../constant';
import getDepartmentLabel from '../../utils/getDepartmentLabel';
import getPositionLabel from '../../utils/getPositionLabel';
import './style.css';

const ExcelFile = ReactExport.ExcelFile;
const ExcelSheet = ReactExport.ExcelFile.ExcelSheet;
const ExcelColumn = ReactExport.ExcelFile.ExcelColumn;

const title = 'Staff';

function ExcelExportModalEmployeeFSA({ employees = [], isOpen = false, onClose = () => null }) {
	moment.locale('km');

	const { t } = useTranslation();
	const [colData, setColData] = useState([]);
	const [data, setData] = useState([]);

	function getStatusJobTitleWithEmptyBlank(statusJobTitle) {
		if (statusJobTitle) {
			switch (statusJobTitle) {
				case 'Level_7':
					return 'អនុមន្រ្តីកម្រិត១';
				case 'Level_6':
					return 'អនុមន្រ្តីកម្រិត២';
				case 'Level_5':
					return 'អនុមន្រ្តីកម្រិត៣';
				case 'Level_4':
					return 'នាយក្រមការ';
				case 'Level_3':
					return 'ក្រមការដើមខ្សែ';
				case 'Level_2':
					return 'ក្រមការ';
				case 'Level_1':
					return 'កម្មសិក្សា';
				default:
					return statusJobTitle;
			}
		} else {
			return '';
		}
	}

	function getPorficiencyLabel(proficiency) {
		switch (proficiency) {
			case '1':
				return 'ខ្សោយ';
			case '2':
				return 'មធ្យម';
			case '3':
				return 'ល្អបង្គួរ';
			case '4':
				return 'ល្អ';
			case '5':
				return 'ល្អណាស់';
			default:
				return '';
		}
	}

	useEffect(() => {
		if (employees?.length > 0) {
			let newData = [];
			employees?.forEach((item) => {
				let tmpJobHistory = [];
				item?.inTheFieldOfPublicFunctions?.forEach((item) => {
					tmpJobHistory.push(item);
				});
				item?.inThePrivateSector?.forEach((item) => {
					tmpJobHistory.push(item);
				});
				const jobHistory = _.orderBy(tmpJobHistory, [(obj) => new Date(obj?.endDate)], ['desc']);

				const currentAddressObject = item?.currentAddress ? JSON.parse(item?.currentAddress) : {};
				const pobObject = item?.pob ? JSON.parse(item?.pob) : {};
				const rowData = {
					'A នាយកដ្ឋាន': t(getDepartmentLabel(item?.department)) || '',
					'B ឈ្មោះ': item?.fullName || '',
					'C ឈ្មោះឡាតាំង': item?.fullNameLatin?.toUpperCase() || '',
					'D ភេទ': (item?.gender === 'male' ? 'ប្រុស' : item?.gender === 'female' ? 'ស្រី' : '') || '',
					'E សញ្ជាតិ': '',
					'F ថ្ងៃខែឆ្នាំកំណើត': item?.dob ? moment(item?.dob).format(c.excelDateOnlyTextFormat) : '' || '',
					'G ភូមិ POB': (item?.isPobManual ? item?.pobManual : pobObject?.village?.[0]?.name) || '',
					'H ឃុំ /សង្កាត់ POB': pobObject?.commune?.[0]?.name || '',
					'I ក្រុង /ស្រុក /ខណ្ឌ POB': pobObject?.district?.[0]?.name || '',
					'J រាជធានី /ខេត្ត POB': pobObject?.province?.[0]?.name || '',
					'K កម្រិតវប្បធម៌': getDegreeName(item?.degree) || '',
					'L អង្គភាព /ទីកន្លែងបំពេញការងារ': 'និយ័តករធានារ៉ាប់រងកម្ពុជា',
					'M ភារកិច្ចទទួលខុសត្រូវ': '',
					'N លេខអត្តសញ្ញាណបណ្ណសញ្ជាតិខ្មែរ': item?.idCardNumber || '',
					'O កាលបរិច្ឆេទផុតកំណត់អត្តសញ្ញាណបណ្ណសញ្ជាតិខ្មែរ': item?.idCardExpirationDate
						? moment(item?.idCardExpirationDate).format(c.excelDateOnlyTextFormat)
						: '',
					'P លេខគណនី (ប្រាក់រៀល)': '',
					'Q ផ្ទះលេខ': currentAddressObject?.streetNumber || '',
					'R ផ្លូវលេខ': currentAddressObject?.houseNumber || '',
					'S ភូមិ': (item?.isCurrentAddressManual ? item?.currentAddressManual : currentAddressObject?.village?.[0]?.name) || '',
					'T ឃុំ /សង្កាត់': currentAddressObject?.commune?.[0]?.name || '',
					'U ក្រុង /ស្រុក /ខណ្ឌ': currentAddressObject?.district?.[0]?.name || '',
					'V រាជធានី /ខេត្ត': currentAddressObject?.province?.[0]?.name || '',
					'W លេខទូរស័ព្ទ': item?.phoneNumber || '',
					'X Email': item?.email || '',
					//ព័ត៌មានអំពីគ្រួសារ
					'Y ឈ្មោះប្ដី/ប្រពន្ធ': item?.spouseStatus?.spouseName || '',
					'Z អក្សរពុម្ពឡាតាំង': item?.spouseStatus?.spouseNameLatin || '',
					'AA ស្ថានភាព': item?.spouseStatus?.spouseStatus || '',
					'AB ថ្ងៃខែឆ្នាំកំណើត': item?.spouseStatus?.spouseDob ? moment(item?.spouseStatus?.spouseDob).format(c.excelDateOnlyTextFormat) : '',
					'AC មុខរបរ': item?.spouseStatus?.spouseJob || '',
					'AD អង្គភាព': item?.spouseStatus?.spouseJobInstitution || '',
					'AE ចំនួនកូន': item?.childInformation?.length || '',
					//ព័ត៌មានអំពីស្ថានភាពមុខងារបច្ចុប្បន្ន
					'AF កាលបរិច្ឆេទចូលបម្រើការងារដំបូង ': item?.firstWorkingPlace?.firstWorkingstartDate
						? moment(item?.firstWorkingPlace?.firstWorkingstartDate).format(c.excelDateOnlyTextFormat)
						: '',
					'AG ប្រភេទ': '',
					'AH ថ្នាក់': getStatusJobTitleWithEmptyBlank(item?.currentWorkingStatus?.currentWorkingStatusJobTitle),
					'AI មុខតំណែង ': item?.currentWorkingStatus?.currentWorkingStatusPosition
						? getPositionLabel(item?.currentWorkingStatus?.currentWorkingStatusPosition)
						: '',
					'AJ អង្គភាព': item?.currentWorkingStatus?.currentWorkingStatusOrganization || 'និយ័តករធានារ៉ាប់រងកម្ពុជា',
					'AK នាយកដ្ឋាន': t(getDepartmentLabel(item?.department)) || '',
					'AL ការិយាល័យ': item?.office || '',
					// កម្រិតវប្បធម៌ទូទៅ
					'AM វគ្គ ឬកម្រិតសិក្សា': item?.generalEducation?.[0]?.courseOrLevelOfStudy || '',
					'AN គ្រឹះស្ថានសិក្សាបណ្តុះបណ្តាល និងទីកន្លែង': item?.generalEducation?.[0]?.trainingInstitutions || '',
					'AO សញ្ញាបត្រដែលទទួលបាន': item?.generalEducation?.[0]?.DegreeObtained || '',
					'AP ថ្ងៃខែឆ្នាំចូលសិក្សា': item?.generalEducation?.[0]?.dateOfEnrollment
						? moment(item?.generalEducation?.[0]?.dateOfEnrollment).format(c.excelDateOnlyTextFormat)
						: '',
					'AQ ថ្ងៃខែឆ្នាំបញ្ចប់ការសិក្សា': item?.generalEducation?.[0]?.dateOfGraduation
						? moment(item?.generalEducation?.[0]?.dateOfGraduation).format(c.excelDateOnlyTextFormat)
						: '',
					// កម្រិតសញ្ញាបត្រ
					// 1
					'AR វគ្គ ឬកម្រិតសិក្សា': item?.degree?.[0]?.courseOrLevelOfStudy || '',
					'AS គ្រឹះស្ថានសិក្សាបណ្តុះបណ្តាល និងទីកន្លែង': item?.degree?.[0]?.trainingInstitutions || '',
					'AT សញ្ញាបត្រដែលទទួលបាន': item?.degree?.[0]?.DegreeObtained || '',
					'AU ថ្ងៃខែឆ្នាំចូលសិក្សា': item?.degree?.[0]?.dateOfEnrollment
						? moment(item?.degree?.[0]?.dateOfEnrollment).format(c.excelDateOnlyTextFormat)
						: '',
					'AV ថ្ងៃខែឆ្នាំបញ្ចប់ការសិក្សា': item?.degree?.[0]?.dateOfGraduation
						? moment(item?.degree?.[0]?.dateOfGraduation).format(c.excelDateOnlyTextFormat)
						: '',
					// 2
					'AW វគ្គ ឬកម្រិតសិក្សា': item?.degree?.[1]?.courseOrLevelOfStudy || '',
					'AX គ្រឹះស្ថានសិក្សាបណ្តុះបណ្តាល និងទីកន្លែង': item?.degree?.[1]?.trainingInstitutions || '',
					'AY សញ្ញាបត្រដែលទទួលបាន': item?.degree?.[1]?.DegreeObtained || '',
					'AZ ថ្ងៃខែឆ្នាំចូលសិក្សា': item?.degree?.[1]?.dateOfEnrollment
						? moment(item?.degree?.[1]?.dateOfEnrollment).format(c.excelDateOnlyTextFormat)
						: '',
					'BA ថ្ងៃខែឆ្នាំបញ្ចប់ការសិក្សា': item?.degree?.[1]?.dateOfGraduation
						? moment(item?.degree?.[1]?.dateOfGraduation).format(c.excelDateOnlyTextFormat)
						: '',
					// 3
					'BB វគ្គ ឬកម្រិតសិក្សា': item?.degree?.[2]?.courseOrLevelOfStudy || '',
					'BC គ្រឹះស្ថានសិក្សាបណ្តុះបណ្តាល និងទីកន្លែង': item?.degree?.[2]?.trainingInstitutions || '',
					'BD សញ្ញាបត្រដែលទទួលបាន': item?.degree?.[2]?.DegreeObtained || '',
					'BE ថ្ងៃខែឆ្នាំចូលសិក្សា': item?.degree?.[2]?.dateOfGraduation
						? moment(item?.degree?.[2]?.dateOfGraduation).format(c.excelDateOnlyTextFormat)
						: '',
					'BF ថ្ងៃខែឆ្នាំបញ្ចប់ការសិក្សា': item?.degree?.[2]?.dateOfGraduation
						? moment(item?.degree?.[2]?.dateOfGraduation).format(c.excelDateOnlyTextFormat)
						: '',
					// ជំនាញឯកទេស
					// 1
					'BG វគ្គ ឬកម្រិតសិក្សា': item?.specialization?.[0]?.courseOrLevelOfStudy || '',
					'BH គ្រឹះស្ថានសិក្សាបណ្តុះបណ្តាល និងទីកន្លែង': item?.specialization?.[0]?.trainingInstitutions || '',
					'BI សញ្ញាបត្រដែលទទួលបាន': item?.specialization?.[0]?.DegreeObtained || '',
					'BJ ថ្ងៃខែឆ្នាំចូលសិក្សា': item?.specialization?.[0]?.dateOfGraduation
						? moment(item?.specialization?.[0]?.dateOfGraduation).format(c.excelDateOnlyTextFormat)
						: '',
					'BK ថ្ងៃខែឆ្នាំបញ្ចប់ការសិក្សា': item?.specialization?.[0]?.dateOfGraduation
						? moment(item?.specialization?.[0]?.dateOfGraduation).format(c.excelDateOnlyTextFormat)
						: '',
					// 2
					'BL វគ្គ ឬកម្រិតសិក្សា': item?.specialization?.[1]?.courseOrLevelOfStudy || '',
					'BM គ្រឹះស្ថានសិក្សាបណ្តុះបណ្តាល និងទីកន្លែង': item?.specialization?.[1]?.trainingInstitutions || '',
					'BN សញ្ញាបត្រដែលទទួលបាន': item?.specialization?.[1]?.DegreeObtained || '',
					'BO ថ្ងៃខែឆ្នាំចូលសិក្សា': item?.specialization?.[1]?.dateOfGraduation
						? moment(item?.specialization?.[1]?.dateOfGraduation).format(c.excelDateOnlyTextFormat)
						: '',
					'BP ថ្ងៃខែឆ្នាំបញ្ចប់ការសិក្សា': item?.specialization?.[1]?.dateOfGraduation
						? moment(item?.specialization?.[1]?.dateOfGraduation).format(c.excelDateOnlyTextFormat)
						: '',
					// 3
					'BQ វគ្គ ឬកម្រិតសិក្សា': item?.specialization?.[2]?.courseOrLevelOfStudy || '',
					'BR គ្រឹះស្ថានសិក្សាបណ្តុះបណ្តាល និងទីកន្លែង': item?.specialization?.[2]?.trainingInstitutions || '',
					'BS សញ្ញាបត្រដែលទទួលបាន': item?.specialization?.[2]?.DegreeObtained || '',
					'BT ថ្ងៃខែឆ្នាំចូលសិក្សា': item?.specialization?.[2]?.dateOfGraduation
						? moment(item?.specialization?.[2]?.dateOfGraduation).format(c.excelDateOnlyTextFormat)
						: '',
					'BU ថ្ងៃខែឆ្នាំបញ្ចប់ការសិក្សា': item?.specialization?.[2]?.dateOfGraduation
						? moment(item?.specialization?.[2]?.dateOfGraduation).format(c.excelDateOnlyTextFormat)
						: '',
					// ប្រវត្តិការងារ,
					// 1
					'BV ចូល': jobHistory?.[0]?.startDate ? moment(jobHistory?.[0]?.startDate).format(c.excelDateOnlyTextFormat) : '',
					'BW បញ្ចប់': jobHistory?.[0]?.endDate ? moment(jobHistory?.[0]?.endDate).format(c.excelDateOnlyTextFormat) : '',
					'BX ក្រសួង/ស្ថាប័ន': jobHistory?.[0]?.institution || jobHistory?.[0]?.institutionDivision,
					'BY អង្គភាព': jobHistory?.[0]?.division || '',
					'BZ មុខតំណែង': jobHistory?.[0]?.position || '',
					// 2
					'CA ចូល': jobHistory?.[1]?.startDate ? moment(jobHistory?.[1]?.startDate).format(c.excelDateOnlyTextFormat) : '',
					'CB បញ្ចប់': jobHistory?.[1]?.endDate ? moment(jobHistory?.[1]?.endDate).format(c.excelDateOnlyTextFormat) : '',
					'CC ក្រសួង/ស្ថាប័ន': jobHistory?.[1]?.institution || jobHistory?.[1]?.institutionDivision,
					'CD អង្គភាព': jobHistory?.[1]?.division || '',
					'CE មុខតំណែង': jobHistory?.[1]?.position || '',
					// 3
					'CF ចូល': jobHistory?.[2]?.startDate ? moment(jobHistory?.[2]?.startDate).format(c.excelDateOnlyTextFormat) : '',
					'CG បញ្ចប់': jobHistory?.[2]?.endDate ? moment(jobHistory?.[2]?.endDate).format(c.excelDateOnlyTextFormat) : '',
					'CH ក្រសួង/ស្ថាប័ន': jobHistory?.[2]?.institution || jobHistory?.[2]?.institutionDivision,
					'CI អង្គភាព': jobHistory?.[2]?.division || '',
					'CJ មុខតំណែង': jobHistory?.[2]?.position || '',
					// សមត្ថភាពភាសាបរទេស
					// 1
					'CK ភាសា': item?.foreignLanguage?.[0]?.language,
					'CL អាន': getPorficiencyLabel(item?.foreignLanguage?.[0]?.read),
					'CM សរសេរ': getPorficiencyLabel(item?.foreignLanguage?.[0]?.write),
					'CN និយាយ': getPorficiencyLabel(item?.foreignLanguage?.[0]?.speak),
					'CO ស្តាប់': getPorficiencyLabel(item?.foreignLanguage?.[0]?.listen),
					// 2
					'CP ភាសា': item?.foreignLanguage?.[0]?.language,
					'CQ អាន': getPorficiencyLabel(item?.foreignLanguage?.[0]?.read),
					'CR សរសេរ': getPorficiencyLabel(item?.foreignLanguage?.[0]?.write),
					'CS និយាយ': getPorficiencyLabel(item?.foreignLanguage?.[0]?.speak),
					'CT ស្តាប់': getPorficiencyLabel(item?.foreignLanguage?.[0]?.listen),
					// 3
					'CU ភាសា': item?.foreignLanguage?.[0]?.language,
					'CV អាន': getPorficiencyLabel(item?.foreignLanguage?.[0]?.read),
					'CW សរសេរ': getPorficiencyLabel(item?.foreignLanguage?.[0]?.write),
					'CX និយាយ': getPorficiencyLabel(item?.foreignLanguage?.[0]?.speak),
					'CY ស្តាប់': getPorficiencyLabel(item?.foreignLanguage?.[0]?.listen),
					'CZ ស្ថានភាព': getPorficiencyLabel(item?.active ? t('Active') : t('Inactive')),
				};
				newData.push(rowData);
			});
			setData(newData);
		}
	}, [employees]);

	function getDegreeName(degree) {
		let res = '';
		if (degree) {
			degree.forEach((item, index) => {
				res = res + `${index > 0 ? ' / ' : ''}` + item?.DegreeObtained;
			});
		}
		return res;
	}

	function convertCamelCaseToCaseText(text) {
		const result = text?.replace(/([A-Z])/g, ' $1');
		return result?.charAt(0).toUpperCase() + result?.slice(1);
	}

	useEffect(() => {
		if (data?.length > 0) {
			const row = data[0];
			const rowData = [];
			for (var k in row) {
				if (row.hasOwnProperty(k)) {
					rowData.push({ label: convertCamelCaseToCaseText(k), value: k });
				}
			}
			setColData(rowData);
		}
	}, [data]);

	return (
		<Modal isOpen={isOpen} onClose={onClose} size="md">
			<ModalOverlay />
			<ModalContent pb="4" borderRadius={c.borderRadius}>
				<ModalHeader>{t('Export To Excel')}</ModalHeader>
				<ModalCloseButton />
				<ModalBody>
					<Box w="100%" pt="16px" pb="16px">
						{data.length > 0 && (
							<ExcelFile
								filename={`${title} - Generated At ${moment().format('DD MM YYYY hh mm ss')}`}
								element={
									<Button variant="solid" size="md" h="42px" w="128px" type="submit" borderRadius={c.borderRadius} color="#3498db">
										{t('Download')}
									</Button>
								}
							>
								<ExcelSheet data={data} name={`Table`}>
									{colData?.map((item, index) => {
										return <ExcelColumn key={`k-${index}`} label={item?.label} value={item?.value} />;
									})}
								</ExcelSheet>
							</ExcelFile>
						)}
					</Box>
				</ModalBody>
			</ModalContent>
		</Modal>
	);
}

export default ExcelExportModalEmployeeFSA;
